// Shopify sirve cualquier imagen de su CDN ya redimensionada si se le anade
// `width` como query param (funciona junto a `?v=...` sin romperlo) -- las
// fotos que sube un vendedor con tienda Shopify (import de productos) llegan
// a tamano original (1000px+), pero se muestran en tarjetas de ~150-350px,
// asi que PageSpeed las señala como "imagen mas grande de lo necesario".
// Solo se toca `cdn.shopify.com`: cualquier otro origen (feed de afiliados,
// AliExpress...) se deja intacto porque no soporta este parametro.
export function withShopifyWidth(url, width) {
    if (!url) return url;
    try {
        const parsed = new URL(url);
        if (!/(^|\.)cdn\.shopify\.com$/i.test(parsed.hostname)) return url;
        parsed.searchParams.set('width', String(width));
        return parsed.toString();
    } catch {
        return url;
    }
}
